module.exports = __webpack_public_path__ + "static/logo-f1147a177ffd36dda92c03f185d32835.png";